import {
    Chip,
    Input,
    Navbar,
    NavbarBrand,
    NavbarContent,
    NavbarItem,
    Table,
    TableBody,
    TableCell,
    TableColumn,
    TableHeader,
    TableRow,
    Modal,
    ModalContent,
    Button,
    ModalFooter,
    ModalBody,
    ModalHeader,
    Pagination, Image,
    Tabs, Tab, Card, CardBody,
} from "@heroui/react";
import { RSKLogo } from "../../components/NavBar";
import { CgDarkMode } from "react-icons/cg";
import React, { useState, useMemo, useCallback } from "react";
import { Icon } from "@iconify/react";
import { apiClientExporter } from "../../services/apiClient";
import generateClaimLetter from "../../components/claim/CartaReclamoHelper";
import { saveAs } from "file-saver";
import { useTheme } from "@heroui/use-theme";
import DetalleQuickviewExporter from "./DetalleQuickviewExporter";
import DetalleMaestraEditar from "./DetalleMaestraEditar";
import DetalleJudicialEditar from "./DetalleJudicialEditar";
import { format, differenceInDays } from "date-fns";
import PlanillaJudicial from "./PlanillaJudicial";
import ResumenInteligente from "./ResumenInteligente";
import { motion, AnimatePresence } from "framer-motion";

// Search Icon Component
const SearchIcon = (props) => (
    <svg
        aria-hidden="true"
        fill="none"
        focusable="false"
        height="1em"
        role="presentation"
        viewBox="0 0 24 24"
        width="1em"
        {...props}
    >
        <path
            d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
        />
        <path
            d="M22 22L20 20"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
        />
    </svg>
);

function ExporterContent({ data, onLogout, profileData }) {
    const adm_email = "admin@rskchile.com";
    const { theme, setTheme } = useTheme();
    // Initialize tableData with the data prop from AuthController
    const [tableData] = useState(data || []);
    const [profile] = useState(profileData || null);
    

    const [filterValue, setFilterValue] = useState("");
    const [isQuickViewModalOpen, setIsQuickViewModalOpen] = useState(false);
    const [isDocumentModalOpen, setIsDocumentModalOpen] = useState(false);
    const [selectedRskRef, setSelectedRskRef] = useState(null);
    // Suppress unused variable warning as docxBlob is used in API call
    // eslint-disable-next-line no-unused-vars
    const [docxBlob, setDocxBlob] = useState(null);
    const [pdfBlob, setPdfBlob] = useState(null);
    const [documentFilename, setDocumentFilename] = useState("");
    const [isGeneratingDocument, setIsGeneratingDocument] = useState(false);
    // Pagination and sorting states
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [sortDescriptor, setSortDescriptor] = useState({
        column: "rsk_ref",
        direction: "descending",
    });
    //check if user has admin view (profile_id 2, 5 ,6)
    const adminView = (profileid) => {
        if (!profileid) {
            return false;
        } else {
            return profileid === 2 || profileid === 5 || profileid === 6;
        }
    }
    //MANEJO DE ESTADO PARA EDITAR MAESTRA
    const [maestraLoading, setMaestraLoading] = useState(false);
    const [maestraData, setMaestraData] = useState(null);
    const [isMaestraModalOpen, setIsMaestraModalOpen] = useState(false);
    const [selectedTab, setSelectedTab] = useState("maestra");

    // Función para determinar el color basado en los días que faltan
    const getDiasColor = (diasQueFaltan) => {
        if (diasQueFaltan === "N/A" || diasQueFaltan === "Vencido") {
            return "text-gray-500"; // Gris para N/A y Vencido
        }
        
        const dias = parseInt(diasQueFaltan);
        if (isNaN(dias)) return "text-gray-500";
        
        if (dias <= 30) {
            return "text-red-600 font-bold"; // Rojo para 30 días o menos
        } else if (dias <= 60) {
            return "text-yellow-600 font-semibold"; // Amarillo para 31-60 días
        } else {
            return "text-green-600"; // Verde para más de 60 días
        }
    };

    // Función para calcular automáticamente los días que faltan
    const calcularDiasQueFaltan = (timeBar, timeExtension, fechaArribo) => {
        const hoy = new Date();
        hoy.setHours(0, 0, 0, 0); // Resetear a inicio del día para comparación precisa

        let fechaReferencia = null;

        // Si existe time_extension, usarla como fecha de referencia
        if (timeExtension) {
            fechaReferencia = new Date(timeExtension);
            console.log("ExporterContent - Usando time_extension:", timeExtension, "fechaReferencia:", fechaReferencia);
        }
        // Si no existe time_extension pero existe time_bar, usar time_bar
        else if (timeBar) {
            // timeBar puede venir en formato ISO (2027-02-17T03:00:00.000Z) o dd-MM-yyyy
            if (timeBar.includes("T")) {
                // Formato ISO
                fechaReferencia = new Date(timeBar);
            } else {
                // Formato dd-MM-yyyy
                const [day, month, year] = timeBar.split("-");
                fechaReferencia = new Date(`${year}-${month}-${day}`);
            }
            console.log("ExporterContent - Usando time_bar:", timeBar, "fechaReferencia:", fechaReferencia);
        }
        // Si no hay time_extension ni time_bar, calcular desde fecha_arribo + 730 días
        else if (fechaArribo) {
            const fechaArriboDate = new Date(fechaArribo);
            fechaArriboDate.setDate(fechaArriboDate.getDate() + 730);
            fechaReferencia = fechaArriboDate;
            console.log("ExporterContent - Usando fecha_arribo + 730:", fechaArribo, "fechaReferencia:", fechaReferencia);
        }

        if (!fechaReferencia || isNaN(fechaReferencia.getTime())) {
            console.log("ExporterContent - No se pudo calcular fecha de referencia");
            return "N/A";
        }

        // Crear fechas sin zona horaria usando solo la fecha
        const fechaReferenciaSinTZ = new Date(fechaReferencia.getFullYear(), fechaReferencia.getMonth(), fechaReferencia.getDate());
        const hoySinTZ = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate());
        
        const diasDiferencia = differenceInDays(fechaReferenciaSinTZ, hoySinTZ);

        console.log("ExporterContent - Cálculo final:", {
            fechaReferencia,
            fechaReferenciaSinTZ,
            hoySinTZ,
            diasDiferencia
        });

        if (diasDiferencia <= 0) {
            return "Vencido";
        } else {
            return diasDiferencia.toString();
        }
    };

    // Define table columns, including exporter_name for admin users
    const columns = useMemo(() => {
        const baseColumns = [
            { name: "RSK Ref.", uid: "rsk_ref", sortable: true },
            { name: "Client Ref.", uid: "ref_number1", sortable: true },
            { name: "Vessel", uid: "vessel", sortable: true },
            { name: "BL/AWB", uid: "bl_awb", sortable: true },
            { name: "Container", uid: "container_number", sortable: true },
            { name: "Carrier", uid: "carrier_name", sortable: true },
            { name: "Claim Amount", uid: "claimamount", sortable: true },
            { name: "Actions", uid: "actions", sortable: false },
        ];
        if (adminView(profile?.profile_id)) { //2 admin, 5 recovery, 6 administracion
            return [
                baseColumns[0],
                { name: "Exporter name", uid: "exporter_name", sortable: true },
                { name: "Days Remaining", uid: "time_bar", sortable: true },
                ...baseColumns.slice(1),
            ];
        }
        return baseColumns;
    }, [profile]);

    // Toggle between light and dark theme
    const toggleTheme = () => {
        setTheme(theme === "light" ? "dark" : "light");
        console.log("profile", profile);
    };

    // Handle logout
    const handleLogout = () => {
        localStorage.removeItem("exporterAuthToken");
        if (onLogout) onLogout();
    };

    // Memoized search input handlers
    const onSearchChange = useCallback((value) => {
        if (value) {
            setFilterValue(value);
            setPage(1);
        } else {
            setFilterValue("");
        }
    }, []);

    const onClear = useCallback(() => {
        setFilterValue("");
        setPage(1);
    }, []);

    // Filter the table data based on search input, including exporter_name for admin users
    const filteredData = useMemo(() => {
        let filtered = tableData || [];
        
        if (filterValue) {
            const lowerCaseFilter = filterValue.toLowerCase();
            filtered = filtered.filter((row) => {
                if (!row) return false;
                return [
                    row.rsk_ref,
                    row.ref_number1,
                    row.vessel,
                    row.bl_awb,
                    row.container_number,
                    row.carrier_name,
                    row.claimamount?.toString(),
                    ...(adminView(profile?.profile_id) ? [
                        row.exporter_name || "",
                        calcularDiasQueFaltan(row.time_bar, row.time_extension, row.fecha_arribo)
                    ] : []),
                ].some((value) => value?.toString().toLowerCase().includes(lowerCaseFilter));
            });
        }
        
        // Pre-calculate days remaining for all filtered items
        return filtered.map(row => ({
            ...row,
            diasQueFaltan: calcularDiasQueFaltan(row.time_bar, row.time_extension, row.fecha_arribo)
        }));
    }, [tableData, filterValue, profile]);

    // calculate the total claim amount from filtered data
    const totalClaimAmount = useMemo(() => {
        return filteredData.reduce((sum, row) => sum + (row.claimamount || 0), 0);
    }, [filteredData]);

    // Sort all filtered data based on sortDescriptor
    const sortedData = useMemo(() => {
        if (sortDescriptor.column === "time_bar") {
            return [...filteredData].sort((a, b) => {
                const diasA = a.diasQueFaltan;
                const diasB = b.diasQueFaltan;
                
                // Manejar casos especiales - "N/A" y "Vencido" van al final
                if (diasA === "N/A" && diasB === "N/A") return 0;
                if (diasA === "N/A") return 1; // N/A siempre va al final
                if (diasB === "N/A") return -1;
                
                if (diasA === "Vencido" && diasB === "Vencido") return 0;
                if (diasA === "Vencido") return 1; // Vencido va después de números pero antes que N/A
                if (diasB === "Vencido") return -1;
                
                // Comparar como números
                const numA = parseInt(diasA);
                const numB = parseInt(diasB);
                
                // Verificar que los números sean válidos
                if (isNaN(numA) || isNaN(numB)) {
                    return 0;
                }
                
                const cmp = numA - numB;
                return sortDescriptor.direction === "descending" ? -cmp : cmp;
            });
        }
        
        return [...filteredData].sort((a, b) => {
            const first = a[sortDescriptor.column];
            const second = b[sortDescriptor.column];
            const cmp = first < second ? -1 : first > second ? 1 : 0;
            return sortDescriptor.direction === "descending" ? -cmp : cmp;
        });
    }, [sortDescriptor, filteredData]);

    // Calculate pagination
    const pages = Math.ceil(sortedData.length / rowsPerPage) || 1;

    const items = useMemo(() => {
        const start = (page - 1) * rowsPerPage;
        const end = start + rowsPerPage;
        return sortedData.slice(start, end);
    }, [page, sortedData, rowsPerPage]);

    // QuickView modal handlers
    const openQuickView = (rskRef) => {
        setSelectedRskRef(rskRef);
        setIsQuickViewModalOpen(true);
    };

    const closeQuickViewModal = () => {
        setIsQuickViewModalOpen(false);
        setSelectedRskRef(null);
    };

    const closeMaestraModal = () => {
        setIsMaestraModalOpen(false);
        setMaestraData(null);
        setSelectedTab("maestra"); // Resetea el tab al cerrar
    }

    // Document modal handlers
    const closeDocumentModal = () => {
        setIsDocumentModalOpen(false);
        setDocxBlob(null);
        setPdfBlob(null);
        setDocumentFilename("");
    };

    // Generate claim letter document
    const handleGenerateDocument = async (rsk_ref) => {
        console.log("Iniciando generación de documento para rsk_ref:", rsk_ref);
        setIsGeneratingDocument(true);
        setSelectedRskRef(rsk_ref);

        try {
            const response = await apiClientExporter.get(`/exporter/reclamo?rsk_ref=${rsk_ref}`);
            const reclamoData = response.data;
            console.log("Datos de reclamo:", reclamoData);
            const reclamo = Array.isArray(reclamoData) ? reclamoData[0] : reclamoData;

            const { blob, filename } = await generateClaimLetter(rsk_ref, reclamo, false);
            setDocxBlob(blob);
            setDocumentFilename(filename);
            console.log("Documento DOCX generado:", filename);

            const pdfResponse = await apiClientExporter.post('/exporter/convert-to-pdf', blob, {
                headers: {
                    'Content-Type': 'application/octet-stream',
                },
                responseType: 'blob',
            });

            const pdfBlob = new Blob([pdfResponse.data], { type: 'application/pdf' });
            setPdfBlob(pdfBlob);
            setIsDocumentModalOpen(true);
            console.log("PDF generado y modal abierto");
        } catch (error) {
            console.error("Error generando documento o convirtiendo a PDF:", error);
            alert("Ocurrió un error al generar el documento o la previsualización. Por favor, intenta de nuevo.");
        } finally {
            console.log("Finalizando generación de documento para rsk_ref:", rsk_ref);
            await new Promise((resolve) => setTimeout(resolve, 500)); // Retraso mínimo para asegurar visibilidad
            //setIsGeneratingDocument(false);
            setSelectedRskRef(null);
        }
    };

    // Download the generated PDF
    const handleDownload = () => {
        if (pdfBlob && documentFilename) {
            const pdfFilename = documentFilename.replace(/\.docx$/, '.pdf');
            saveAs(pdfBlob, pdfFilename);
        }
    };

    const handleEditMaster = async (id) => {
        if (!id || maestraLoading) {
            alert('operacion no valida!')
            return
        }
        setMaestraLoading(true)

        try {
            const response = await apiClientExporter.get(`/exporter/maestra?id=${id}`);
            const data = response.data;
            setMaestraData(data)
            console.log("data", data);
            setIsMaestraModalOpen(true);
        } catch (err) {
            console.error(err.message);
        } finally {
            console.log("Finalizando editar Maestra");
            setMaestraLoading(false)
        }
    };

    // Define the top content for search and pagination
    const topContent = useMemo(() => {
        return (
            <div className="flex flex-col gap-4">
                <div className="flex justify-between gap-3 items-end">
                    <Input
                        isClearable
                        className="w-full sm:max-w-[44%]"
                        placeholder="Search by RSK Ref, BL/AWB, Exporter, etc."
                        startContent={<SearchIcon />}
                        value={filterValue}
                        onClear={onClear}
                        onValueChange={onSearchChange}
                        variant="bordered"
                        radius="md"
                        color="primary"
                    />
                </div>
                <div className="flex justify-between items-center">
                    <span className="text-default-400 text-small">Total {filteredData.length} claims</span>
                    <span className="text-default-400 text-small">
                    Total claim amount: $
                        {new Intl.NumberFormat("es-CL", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        }).format(totalClaimAmount)}
                </span>
                    <label className="flex items-center text-default-400 text-small">
                        Rows per page:
                        <select
                            className="bg-transparent outline-none text-default-400 text-small ml-2"
                            value={rowsPerPage}
                            onChange={(e) => {
                                const newRows = e.target.value === "all" ? filteredData.length : Number(e.target.value);
                                setRowsPerPage(newRows);
                                setPage(1); // Siempre vuelve a la primera página al cambiar el tamaño
                            }}
                        >
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="50">50</option>
                            <option value="all">All</option>
                        </select>
                    </label>
                </div>
            </div>
        );
    }, [filterValue, filteredData.length, onSearchChange, onClear, rowsPerPage, totalClaimAmount]);

    // Bottom content for pagination
    const bottomContent = useMemo(() => {
        return (
            <div className="py-2 px-2 flex justify-between items-center">
                <Pagination
                    isCompact
                    showControls
                    showShadow
                    color="primary"
                    page={page}
                    total={pages}
                    onChange={setPage}
                />
                <div className="hidden sm:flex w-[30%] justify-end gap-2">
                    <Button
                        isDisabled={page <= 1}
                        size="sm"
                        variant="flat"
                        onPress={() => setPage((prev) => Math.max(1, prev - 1))}
                    >
                        Previous
                    </Button>
                    <Button
                        isDisabled={page >= pages}
                        size="sm"
                        variant="flat"
                        onPress={() => setPage((prev) => Math.min(pages, prev + 1))}
                    >
                        Next
                    </Button>
                </div>
            </div>
        );
    }, [page, pages]);

// Validate profile and tableData before rendering
    if (!profile || !tableData) {
        return <div>Loading...</div>;
    }
    // if (tableData.length === 0) {
    //     return <div>No data available</div>;
    // }

    return (
        <>
            <Navbar className="mb-2">
                <NavbarBrand>
                    <div className="flex gap-1 justify-center items-center" >
                        <RSKLogo />
                        <Image
                            src= {process.env.PUBLIC_URL + "/PoweredBy.png"}
                            className="max-w-[55px] max-h-[30px] object-contain"
                            width={55}
                            height={30}
                            alt="AWS Logo"
                        />
                    </div>
                </NavbarBrand>
                <NavbarContent className="hidden sm:flex gap-4" justify="center">
                    <NavbarItem>
                        <Chip>{profile.company_name ?? "RSK Quickview"}</Chip>
                    </NavbarItem>
                </NavbarContent>
                <NavbarContent justify="end">
                    {profile?.logo && (
                        <NavbarItem>
                            <Image
                                src={profile.logo}
                                alt="Exporter Logo"
                                className="max-w-[70px] max-h-[40px] object-contain" // Tamaño máximo y proporción
                                width={70} // Tamaño base
                                height={40}
                            />
                        </NavbarItem>
                    )}

                    <NavbarItem>
                        <Button
                            color="secondary"
                            variant="light"
                            onPress={handleLogout}
                            startContent={<Icon icon="mdi:logout" width="20" height="20" />}
                        >
                            Logout
                        </Button>
                    </NavbarItem>
                    <NavbarItem>
                        <Button
                            isIconOnly
                            onPress={toggleTheme}
                            aria-label="Toggle Theme"
                            className="transition-all duration-300 hover:scale-110"
                            style={{ background: 'transparent', border: 'none', boxShadow: 'none', padding: 0 }}
                        >
                            <Icon
                                icon={theme === "light" ? "solar:moon-stars-bold-duotone" : "solar:sun-2-bold-duotone"}
                                width={28}
                                height={28}
                                className={theme === "light" ? "text-blue-700" : "text-yellow-400"}
                            />
                        </Button>
                    </NavbarItem>
                </NavbarContent>
            </Navbar>

            <div className="mx-auto w-full max-w-7xl p-4">
                {/*// Render the table with dynamic columns and cells*/}
                <Table
                    aria-label="Claims details table"
                    isStriped
                    isVirtualized
                    bottomContent={bottomContent}
                    bottomContentPlacement="outside"
                    topContent={topContent}
                    topContentPlacement="outside"
                    sortDescriptor={sortDescriptor}
                    onSortChange={setSortDescriptor}
                    classNames={{
                        wrapper: "max-h-[500px]",
                    }}
                >
                    <TableHeader columns={columns}>
                        {(column) => (
                            <TableColumn
                                key={column.uid}
                                allowsSorting={column.sortable}
                            >
                                {column.name}
                            </TableColumn>
                        )}
                    </TableHeader>
                    <TableBody
                        emptyContent={filterValue ? "No results found" : "No data available"}
                        items={items || []}
                    >
                        {(row) => (
                            <TableRow
                                key={row?.id || Math.random()}
                                initial={{ opacity: 0, y: 10 }}
                                animate={{ opacity: 1, y: 0 }}
                            >
                                {columns.map((column) => (
                                    <TableCell key={column.uid}>
                                        {column.uid === "claimamount" ? (
                                            `$${new Intl.NumberFormat("es-CL", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            }).format(row?.claimamount || 0)}`
                                        ) : column.uid === "actions" ? (
                                            <>
                                                {row?.qvc_id && (
                                                    <>
                                                        <Chip
                                                            color="success"
                                                            size="sm"
                                                            onClick={() => row?.rsk_ref && openQuickView(row.rsk_ref)}
                                                            role="button"
                                                            className="mb-1 mr-1 cursor-pointer hover:bg-opacity-80 active:scale-95 transition-all"
                                                            aria-label={`View details for ${row?.rsk_ref || "unknown"}`}
                                                        >
                                                            QuickView
                                                        </Chip>

                                                        <Chip
                                                            color="primary"
                                                            size="sm"
                                                            onClick={() => {
                                                                if (!isGeneratingDocument && row?.rsk_ref) {
                                                                    handleGenerateDocument(row.rsk_ref);
                                                                }
                                                            }}
                                                            role="button"
                                                            className={`mb-1 mr-1 ${
                                                                isGeneratingDocument || !row?.rsk_ref
                                                                    ? "opacity-50 cursor-not-allowed"
                                                                    : "cursor-pointer hover:bg-opacity-80 active:scale-95 transition-all"
                                                            }`}
                                                            aria-label={`Generate claim letter for ${row?.rsk_ref || "unknown"}`}
                                                        >
                                                        {isGeneratingDocument ? (
                                                            <span className="flex items-center">
                                                                <Icon icon="lucide:loader-2" className="animate-spin mr-1" />
                                                                Loading...
                                                            </span>
                                                            ) : (
                                                            "Claim Letter"
                                                        )}
                                                        </Chip>
                                                    </>
                                                )}

                                                <Chip
                                                    color="danger"
                                                    size="sm"
                                                    isDisabled={maestraLoading}
                                                    onClick={() => handleEditMaster(row.id)}
                                                    role="button"
                                                    className="cursor-pointer hover:bg-opacity-80 active:scale-95 transition-all"
                                                    aria-label={`View details for ${row?.rsk_ref || "unknown"}`}
                                                >
                                                    Edit Record
                                                </Chip>
                                            </>
                                                                                  ) : column.uid === "time_bar" ? (
                                              <span className={getDiasColor(row?.diasQueFaltan)}>
                                                  {row?.diasQueFaltan || "N/A"}
                                              </span>
                                          ) : (
                                            row?.[column.uid] || "N/A"
                                        )}
                                    </TableCell>
                                ))}
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </div>

            {/* QuickView Modal */}
            <Modal
                isOpen={isQuickViewModalOpen}
                onClose={closeQuickViewModal}
                size="full"
                className="max-h-screen overflow-y-auto"
                scrollBehavior="inside"
            >
                <ModalContent>
                    {() => (
                        <>
                            <ModalHeader className="flex flex-col gap-1">QuickView</ModalHeader>
                            <ModalBody>
                                <DetalleQuickviewExporter rskRef={selectedRskRef} />
                            </ModalBody>
                            <ModalFooter>
                                <Button color="danger" variant="light" onPress={closeQuickViewModal}>
                                    Close
                                </Button>
                            </ModalFooter>
                        </>
                    )}
                </ModalContent>
            </Modal>

            {/* Document Preview Modal */}
            <Modal
                isOpen={isDocumentModalOpen}
                onClose={closeDocumentModal}
                size="5xl"
                className="max-h-screen"
            >
                <ModalContent>
                    {() => (
                        <>
                            <ModalHeader className="flex flex-col gap-1">Document Preview</ModalHeader>
                            <ModalBody>
                                {pdfBlob ? (
                                    <iframe
                                        src={URL.createObjectURL(pdfBlob)}
                                        width="100%"
                                        height="600px"
                                        title="Document Preview"
                                        style={{ border: "1px solid #ccc" }}
                                    />
                                ) : (
                                    <div className="text-center">
                                        <p>Loading preview...</p>
                                    </div>
                                )}
                            </ModalBody>
                            <ModalFooter>
                                <Button color="danger" variant="light" onPress={closeDocumentModal}>
                                    Close
                                </Button>
                                <Button color="primary" onPress={handleDownload}>
                                    Download Document (.pdf)
                                </Button>
                            </ModalFooter>
                        </>
                    )}
                </ModalContent>
            </Modal>

            {/* Maestra Edit Modal */}
            <Modal
                isOpen={isMaestraModalOpen}
                onClose={closeMaestraModal}
                size="full"
                className="max-h-screen overflow-y-auto"
                scrollBehavior="inside"
                key={isMaestraModalOpen} // Solo remount al abrir/cerrar
            >
                <ModalContent>
                    <>
                        <ModalHeader>
                            <div className="flex items-center w-full">
                                <div className="flex-1 text-2xl font-bold">
                                    Master Sheet Data{maestraData && maestraData.rsk_ref ? `: ${maestraData.rsk_ref}` : ""}
                                </div>
                                <div className="flex-1 flex justify-center">
                                    <Tabs
                                        aria-label="Opciones de Planilla"
                                        selectedKey={selectedTab}
                                        onSelectionChange={setSelectedTab}
                                    >
                                        <Tab key="maestra" title="Planilla Maestra" />
                                        <Tab key="judicial" title="Planilla Judicial" />
                                        <Tab key="resumen" title={<span className="flex items-center gap-1"><Icon icon="mdi:robot-outline" width={18} height={18} /> Resumen Inteligente</span>} />
                                    </Tabs>
                                </div>
                                <div className="flex-1" />
                            </div>
                        </ModalHeader>
                        <ModalBody>
                            <AnimatePresence>
                                {selectedTab === "maestra" && (
                                    <motion.div
                                        key="maestra"
                                        initial={{ opacity: 0, x: 30 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        exit={{ opacity: 0, x: -30 }}
                                        transition={{ duration: 0.25 }}
                                    >
                                        <DetalleMaestraEditar maestraData={maestraData} />
                                    </motion.div>
                                )}
                                {selectedTab === "judicial" && (
                                    <motion.div
                                        key="judicial"
                                        initial={{ opacity: 0, x: 30 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        exit={{ opacity: 0, x: -30 }}
                                        transition={{ duration: 0.25 }}
                                    >
                                        <Card><CardBody><DetalleJudicialEditar judicialData={maestraData} /></CardBody></Card>
                                    </motion.div>
                                )}
                                {selectedTab === "resumen" && (
                                    <motion.div
                                        key="resumen"
                                        initial={{ opacity: 0, x: 30 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        exit={{ opacity: 0, x: -30 }}
                                        transition={{ duration: 0.25 }}
                                    >
                                        <Card><CardBody><ResumenInteligente resumenData={maestraData} /></CardBody></Card>
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </ModalBody>
                        <ModalFooter>
                            <Button color="danger" variant="light" onPress={closeMaestraModal}>
                                Close
                            </Button>
                        </ModalFooter>
                    </>
                </ModalContent>
            </Modal>


        </>
    )
}

export default ExporterContent;